/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_MonInputs */

const cs_portals_day_mon = /** @type {(inputs: Portals_Day_MonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po`)
};

const en_portals_day_mon = /** @type {(inputs: Portals_Day_MonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon`)
};

/**
* | output |
* | --- |
* | "Mon" |
*
* @param {Portals_Day_MonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_mon = /** @type {((inputs?: Portals_Day_MonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_MonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_mon(inputs)
	return cs_portals_day_mon(inputs)
});